import React from "react";

export default function PageUnderConstruction() {
    return (
      <div className="construct_block under_construct_block_img"></div>
    )
}
